import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import update from 'immutability-helper'
import TInputForm from "../../common/TInputForm";

class GoogleAnalyticsForm extends Component {

    constructor(props) {
        super(props);

        const { onChange, data } = props;

        if(!data.setting.gaCode){
            onChange(update(data, {
                validated : {
                    $set: false
                }
            }))
        }
    }


    @autobind
    handleChangeInput(value) {
        const { onChange, data } = this.props;

        const validated = value.trim().length > 5;

        onChange(update(data, {
            setting: {
                gaCode: {
                    $set: value
                },
            },
            validated : {
                $set: validated 
            }
        }))
    }

    render() {
        const { plugin, data } = this.props;
        const { gaCode } = data.setting;
        return (
            <div className="desc_plugin16">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_plugin">
                    <div className="item_set item_sub">
                        추적 ID
                        <TInputForm className="tf_set tf_set200" placeholder="추적 ID를 넣어주세요." onChange={this.handleChangeInput} value={gaCode}/>
                    </div>
                </div>
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            구글 애널리틱스 가입, 사이트 등록 후 발급받은 추적 ID를 추적 ID 항목에 넣어주세요.  
                            <a href="https://www.google.com/analytics/web/provision?et=&amp;authuser=0#provision/SignUp" target="_blank" className="link_other">설정하러 가기</a>
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                {this.props.saveButton()}
            </div>
        )
    }
}

GoogleAnalyticsForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default GoogleAnalyticsForm
